<action class="button-2 wishlist-icon p-r-0 p-l-0 icon-button wishlist-toggle-size"
        [icon]="inWishlist ? 'wishlist-fill' : 'wishlist'"
        [status]="status"
        notification="Wishlist error"
        (click)="toggle()"
        cy-wishlistAddBtn>
</action>